import { ENV, setEnv } from "../modules/utility";

// File: config.base.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration items used throughout the application.
// Other Contributors:

const moduleGroupMapping = {
    Modules: [
        {
            CAMTL: [
                {
                    GroupName: "MESC_CAMTL_SuperUsers",
                    DisplayName: "Super User",
                    isAdminGroup: true,
                    AppName: "CAMTL"
                },
                {
                    GroupName: "MESC_CAMTL_User_Administrator",
                    DisplayName: "User Admin",
                    isAdminGroup: true,
                    AppName: "CAMTL"
                }
            ],
            TNTS: [
                {
                    GroupName: "MESC_TNTS_SystemAdministrator",
                    DisplayName: "System Admin",
                    isAdminGroup: true,
                    AppName: "TNTS"
                },
                {
                    GroupName: "MESC_TNTS_SpecialUser",
                    DisplayName: "Special User",
                    isAdminGroup: true,
                    AppName: "TNTS"
                },
                {
                    GroupName: "MESC_TNTS_User_Administrator",
                    DisplayName: "User Admin",
                    isAdminGroup: true,
                    AppName: "TNTS"
                }
            ],
            MESC: [
                {
                    GroupName: "MESC_Admin",
                    DisplayName: "System Admin",
                    isAdminGroup: true,
                    AppName: "MESC"
                }

            ]
        }
    ]
}

const CGP_LOGIN_DEV = `https://cgp-game-authn-dev.op-epg1mi.gm.com/authn/?RelayState=`
const CGP_LOGIN_QA = `https://cgp-game-authn-qa.op-epg1mi.gm.com/authn/?RelayState=`
const CGP_LOGIN_TEST = `https://cgp-game-authn-test.op-epg1mi.gm.com/authn/?RelayState=`;
export const cgpLoginUrls = {
    LOCAL: CGP_LOGIN_DEV,
    DEV: CGP_LOGIN_DEV,
    QA: CGP_LOGIN_QA,
    TEST: CGP_LOGIN_TEST,
    PERF: "https://cgp-game-authn-perf.apps.pcfepgwi.gm.com/authn/?RelayState=",
    PROD: "https://mfg-gateway.gm.com/authn/authn/?RelayState="
};

const CGP_SECURITY_DEV = `https://cgp-game-authn-dev.op-epg1mi.gm.com/authn/token/`;
const CGP_SECURITY_QA = `https://cgp-game-authn-qa.op-epg1mi.gm.com/authn/token/`;
const CGP_SECURITY_TEST = `https://cgp-game-authn-test.op-epg1mi.gm.com/authn/token/`;
export const cgpSecurityUrls = {
    LOCAL: CGP_SECURITY_DEV,
    DEV: CGP_SECURITY_DEV,
    QA: CGP_SECURITY_QA,
    TEST: CGP_SECURITY_TEST,
    PERF: "https://cgp-game-authn-perf.apps.pcfepgwi.gm.com/authn/token/",
    PROD: "https://mfg-gateway.gm.com/authn/authn/token/"
};

export const mescServicesUrl = {
    "LOCAL": "http://localhost:41239/api/",
    "DEV": "https://mesc1-api-dev.musea2.azure.ext.gm.com/api/",
    "QA": "https://mesc1-api-ocf-qa.apps.pcfepgstg1mi.gm.com/api/",
    'TEST': 'https://mesc1-api-ocf-test.apps.pcfepgstg1mi.gm.com/api/',
    // "TEST": "https://tnts-test.cp-epg2i.gm.com/api/",
    "PERF": "https://mesc1-api-ocf-perf.apps.pcfepgstg1mi.gm.com/api/",
    "PROD": "https://mesc1-api.musea2.azure.ext.gm.com/api/",
};

export const workflowServicesUrl = {
    "DEV": "http://dcmidavgml0214.nam.corp.gm.com:8082/api/",
    "TEST": "https://mesc-services-test.epga.nam.gm.com/api/",
    "PROD": "https://mesc-srvcs.gm.com/api/",
};

export const workflowServerUrl = {
    version: "10.126.186.229 | Release 2018-02-07 08:33:24",
    "DEV": "https://mesc-service-dev.musea2.azure.ext.gm.com/wf-api/api/",
    "QA": "https://wf-core-api-test.apps.pcfepg2wi.gm.com/api/",
    "TEST": "https://wf-core-api-test.apps.pcfepg2wi.gm.com/api/",
    "PERF": "https://wf-core-api-perf.apps.pcfepg2wi.gm.com/api/",
    "PROD": "https://mesc-service.musea2.azure.ext.gm.com/wf-api/api/",
};

const camtlTestReportURL = `http://dcwitavgml0140/ReportServer/Pages/ReportViewer.aspx?`;
export const camtlReportsUrl = {
    // 'DEV': 'http://epgidvwman1234/ReportServer/Pages/ReportViewer.aspx?'
    // 'DEV': 'http://dcmidavgml0239/ReportServer/Pages/ReportViewer.aspx?', // Broken
    "DEV": camtlTestReportURL,
    "QA": camtlTestReportURL,
    "Test": camtlTestReportURL,
    "PROD": "https://cgp-rpt-svcs.gm.com"
    //'http://dcwipavcgp005/ReportServer/Pages/ReportViewer.aspx?'
};

/**
* 
*/
export const mescUrl = {
    "LOCAL": "http://localhost.gm.com/",
    "DEV": "https://mesc-dev.musea2.azure.ext.gm.com/",
    "QA": "https://mesc-ui-ocf-qa.apps.pcfepgstg1mi.gm.com/",
    "TEST": "https://mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com/",
    "PROD": "https://mesc.musea2.azure.ext.gm.com/"
};

const helpLink = "https://gmweb.gm.com/sites/meITAppTraining/MESC/Forms/AllItems.aspx";

export const baseConfig = {
    appInfo: {
        name: "MESC",
        version: "2.0.2 | Release 2019-08-28 9:42:34",
        company: "GENERAL MOTORS"
    },
    baseUrl: "",
    authentication: {
        authenticationCookie: "Authorization",
        authenticationType: "Bearer",
        userInfoCookie: "UserInfo",
        impersonate: "404536778"
    },
    authorization: {
        admins: {
            "CAMTL": {
                name: "Peter Auernhammer",
                email: "pete.auernhammer@gm.com",
            },
            "TNTS": {
                name: "Scott Singer",
                email: "scott.singer@gm.com",
            },
        }
    },
    help: helpLink,
    modules: moduleGroupMapping
}
